import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'categoryIcon'
})
export class CategoryIconPipe implements PipeTransform {

  transform(category: string, planName: string): string {

    const categories : { [key: string]: string;} = {
      'MED':'medical',
      'DEN':'tooth',
      'VIS':'eye',
      'DRG':'pill-new',
      'CAT':'medical',  /*  'CAT':'medkit', */
      'WEL':'apple',
      'LIF':'life',
      'ADD':'life',
      'DMM':'disease-mgmnt'
    };
    const icon = categories[category];
    if ( category === 'DIS'){
      const planNames : {[key: string]: string;} = {
        'Short Term Disability':'std',
        'Long Term Disability':'ltd',
      };
      const Icon = planNames[planName];
      return Icon ? Icon : '';
    }
    return icon ? icon : '';
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/pipes/category-icon.pipe.ts